import { render, staticRenderFns } from "./instockNum.vue?vue&type=template&id=69913c84&scoped=true&"
import script from "./instockNum.vue?vue&type=script&lang=js&"
export * from "./instockNum.vue?vue&type=script&lang=js&"
import style0 from "./instockNum.vue?vue&type=style&index=0&id=69913c84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69913c84",
  null
  
)

export default component.exports